import ServiciosLocales from '../Data/Servicios.json';
import IMAGENES_SERVICIOS, { FOTOS_HERO } from '../assets/servicios';
import { urlImagen, useConsulta } from './sanity';

/**
 * Servicios, planes y preguntas: los edita el equipo en Sanity, con respaldo en
 * src/Data/Servicios.json. aFormatoLocal deja cada documento con la forma que tenía
 * el JSON, así los componentes del detalle (Planes, Preguntas…) no cambian.
 */

// Frase de la primera oración que va en serif itálica (en Sanity, "Frase destacada")
const DESTACADOS = {
    'transformacion-digital': 'cambio estratégico',
    'marketing-digital': 'maximizar la presencia online',
    'marca-y-diseno': 'a destacar',
    'desarrollo-web-y-aplicaciones': 'herramientas esenciales',
    'app-awnago': 'una aplicación móvil',
    'customer-experience': 'es clave',
};

export const SERVICIOS_LOCALES = ServiciosLocales.map((s) => ({ ...s, destacado: DESTACADOS[s.url] }));

const LISTA = `*[_type == "servicio" && defined(slug.current)] | order(coalesce(orden, 1000) asc, nombre asc)`;

const conTitulo = ({ titulo, descripcion }) => (descripcion ? `${titulo}: ${descripcion}` : titulo);

function aFormatoLocal(d) {
    const preguntas = d.preguntas || [];
    const grupos = [];
    preguntas.forEach((p) => {
        if (!p.grupo) return;
        let grupo = grupos.find((g) => g.title === p.grupo);
        if (!grupo) grupos.push((grupo = { title: p.grupo, preguntas: [] }));
        grupo.preguntas.push({ question: p.pregunta, answer: p.respuesta });
    });

    return {
        id: d._id,
        nombre: d.nombre,
        url: d.slug.current,
        // Como en el JSON: el catálogo y el detalle leen lo que va después de los ":" del
        // título; la lista de la home, el subtítulo
        titulo: `${d.nombre}: ${d.bajada}`,
        subtitulo: d.bajadaHome || d.bajada,
        descripcion: d.descripcion,
        destacado: d.destacado,
        imagen: d.imagen?.asset ? d.imagen : undefined,
        subservicios: d.subservicios,
        explicacion: d.explicacion,
        extra: d.incluidos,
        app: d.app && {
            title: d.app.titulo,
            description: d.app.descripcion,
            contenido: d.app.contenido,
            casosDeUso: d.app.casosDeUso,
            demo: d.app.demo,
        },
        beneficios: d.beneficios?.map(conTitulo),
        detalle: d.categorias?.map((c) => ({
            titulo: c.titulo,
            descripcion: c.descripcion,
            extra: c.extra,
            contenido: (c.planes || []).map((p) => ({
                ...p,
                precios: p.tramos?.map((t) => ({ title: t.titulo, precio: t.precio })),
                inversion: p.inversion && { title: p.inversion.titulo, description: p.inversion.descripcion },
            })),
        })),
        Preguntas: preguntas.map((p) => ({ question: p.pregunta, answer: p.respuesta })),
        preguntasSeparadas: grupos.length ? grupos : undefined,
        mensaje: d.mensaje,
        seo: d.seo,
    };
}

/**
 * `servicios` nunca viene vacío: mientras carga devuelve el respaldo local (para las
 * listas de la home y el catálogo). El detalle espera a `cargando` para no mostrar
 * un texto viejo que después cambia.
 */
export function useServicios() {
    const { datos, cargando } = useConsulta(LISTA, null, null);
    const servicios = datos?.length ? datos.map(aFormatoLocal) : SERVICIOS_LOCALES;
    return { servicios, cargando };
}

/**
 * Foto del servicio. Si el equipo subió una en Sanity, esa; si no, la WebP del
 * repo (800 px) y, al final, la de S3 del JSON.
 */
export function fotoServicio(servicio, ancho = 800) {
    if (servicio.imagen && typeof servicio.imagen === 'object') return urlImagen(servicio.imagen, { ancho });
    return IMAGENES_SERVICIOS[servicio.url] || servicio.imagen;
}

/** Foto a todo el ancho del hero del detalle: las horizontales de FOTOS_HERO si no hay una en Sanity. */
export function fotoHeroServicio(servicio) {
    if (servicio.imagen && typeof servicio.imagen === 'object') return urlImagen(servicio.imagen, { ancho: 2400 });
    return FOTOS_HERO[servicio.url] || fotoServicio(servicio);
}
